//Api or Services
import studentService from "@/services/student.js";
import service from "../api";
import { ACTION_TYPES, MUTATION_TYPES } from "./types";

const actions = {
  async [ACTION_TYPES.GET_USER_STUDENT_SEARCHED_HISTORY]({ commit }) {
    //set last filtered
    service.getStudentHistory().then(function(response) {
      commit(MUTATION_TYPES.ADD_STUDENT_SEARCHED, response.data);
      sessionStorage.setItem("student-history", JSON.stringify(response.data));
    });
  },
  async [ACTION_TYPES.REFRESH_STUDENT_MAIN_INFO]({ state, commit }) {
    let { data } = await studentService.getBySie(state.studentId, false);
    commit("setSelectedStudent", data);
  },
  async [ACTION_TYPES.SET_STUDENT_DETAILS]({ state, commit }, args) {
    //Set Short Information of Student and Save in store details
    await service
      .getStudentDetailsBySie(args.studentId, args.autoCreateStudentData)
      .then(function(response) {
        //todo: Maybe test with alerts for PEI too if route is correct (remove of exception alerts and set here)\
        commit("setStudentId", args.studentId);
        commit("setSelectedStudentDetailst", response.data);

        if (args.selectThisStudent !== true) return;

        let regStudenId = response.data.mipeStudent.regStudentId?.replace(
          "-",
          ""
        );
        
        const student = {
          studentId: response.data.studentId.toString(),
          fullName: response.data.mipeStudent.fullName,
          firstName: response.data.firstName,
          lastName: response.data.lastName,
          statusId: response.data.mipeStudent.studentStatusCode,
          status: response.data.mipeStudent.studentStatusDescription,
          impediment: response.data.mipeStudent.impedimentDescription,
          regStudentId: regStudenId,
          createdDate: args.createdDate,
          canAccess: true,
          isAtConverted: response.data.isAtConverted,
          existsLocally: args.student.existsLocally,
          studentType: response.data.studentType,
          age: response.data.age,
          gradeId: response.data.gradeId
        };

        commit("setSelectedStudent", student);

        if (
          response.data.alerts != undefined &&
          response.data.alerts.length > 0
        ) {
          //TODO: VALIDATE WHY THIS :
          // commit('setSelectedStudentTemp', args.student);
          // commit('setSelectedStudentDetailsTemp', response.data);
          // selectedStudentTemp

          //For avoid save alerts and show alerts modals
          if (!args.viewStudentInfo != undefined && !args.viewStudentInfo) {
            commit(
              MUTATION_TYPES.SET_ALERTS,
              response.data != undefined ? response.data.alerts : null
            );
            commit(MUTATION_TYPES.TOGGLE_SEARCH, true);
          } else {
            commit(MUTATION_TYPES.TOGGLE_SEARCH, false);
          }
        } else {
          commit("setNavigationToViewDisplay", true);
          if (state.navigateToViewRoute) {
            commit("setNavigationToViewRoute", state.navigateToViewRoute);
            commit("setNavigationToViewCard", state.navigateToViewCard);
          }
        }
        commit(MUTATION_TYPES.ADD_STUDENT_SEARCHED, args.student);
        service.saveHistory(args.studentId);
      });
  }
};
export default actions;
